import { PropsWithChildren, FunctionComponent } from 'react';
import { twMerge } from 'src/utils/twMerge';

const SHIMMER_CLASSES =
  'bg-skeleton-shimmer bg-[length:200%_100%] animate-skeleton-shimmer motion-reduce:animate-none motion-reduce:bg-none';

type Props = PropsWithChildren & {
  className?: string;
  'data-testid'?: string;
};

const Skeleton: FunctionComponent<Props> = ({
  className,
  children,
  'data-testid': dataTestId,
}) => (
  <div
    className={`${SHIMMER_CLASSES} ${twMerge('bg-structural-lighter', className)}`}
    data-testid={dataTestId}
  >
    {children}
  </div>
);

export default Skeleton;
